import React, { Component } from "react";
import {
  company,
  loading,
  NavbarWarehouse,
  Pagination,
  Modal,
  GET,
  POST,
  PUT,
  alert,
  Select,
  format_date,
  float,
  t,
  ActionIconButton,
  ACTION_ICONS,
  STICKY_ACTION_STYLE,
  fmtInt,
  fmtQty,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { can } from "../../utils/permission";

export default class PR_PO extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active_tab: this.getStoredActiveTab(), // 'PR' หรือ 'PO'

      data_suppliers: [],
      data_parts: [],
      data_all_pr: [],

      // -----------------------------------
      // Filter & Data States: PR
      // -----------------------------------
      filter_pr_search: "",
      filter_pr_status: "",
      filter_pr_priority: "",
      count_pr: 0,
      page_pr: 1,
      data_pr: [],

      // -----------------------------------
      // Filter & Data States: PO
      // -----------------------------------
      filter_po_search: "",
      filter_po_status: "",
      filter_po_supplier: "",
      count_po: 0,
      page_po: 1,
      data_po: [],

      // -----------------------------------
      // Modal States: PR
      // -----------------------------------
      modal_create_pr: false,
      modal_update_pr: false,
      uid: "",
      status: "pending",
      selected_item: null,
      note: "",
      note_update: "",
      form_pr_priority: "normal",
      form_pr_required_date: "",
      form_pr_reason: "",
      form_pr_supplier_id: "",
      form_pr_note: "",
      form_pr_items: [], // { part_id, uom_id, quantity, estimated_unit_cost, discount, notes }

      // -----------------------------------
      // Modal States: PO
      // -----------------------------------
      modal_create_po: false,
      modal_update_po: false,
      form_po_date: "",
      form_po_due_date: "",
      form_po_pr_id: "",
      form_po_supplier_id: "",
      form_po_note: "",
      form_po_items: [], // { part_id, uom_id, quantity, unit_cost, discount, notes }

      // -----------------------------------
      // Modal States: View Detail
      // -----------------------------------
      modal_view: false,
      view_data: null,
      view_type: "PR", // 'PR' หรือ 'PO'

      // -----------------------------------
      // Mock Summary Stats
      // -----------------------------------
      summary_pr: { total: 0, pending: 0, approved: 0, converted_to_po: 0 },
      summary_po: { total: 0, pending: 0, sent_to_supplier: 0, awaiting_receipt: 0, received: 0 },
    };
  }

  getStoredActiveTab = () => {
    if (typeof window === "undefined") return "PR";
    return window.localStorage.getItem("warehouse_pr_po_active_tab") === "PO" ? "PO" : "PR";
  };

  setActiveTab = (active_tab, callback) => {
    this.setState({ active_tab }, () => {
      if (typeof window !== "undefined") {
        window.localStorage.setItem("warehouse_pr_po_active_tab", active_tab);
      }
      if (callback) callback();
    });
  };

  async componentDidMount() {
    loading(false);
    this.Get();
    this.GetPR(1);
    this.GetPO(1);
  }


    Get = async () => {
      let data_suppliers, data_parts, data_all_pr;
      loading(true);
  
      let [result_suppliers, result_parts, result_pr] = await
        Promise.all([
          GET("warehouse/suppliers",{page_size: 10000,  page: 0}),
          GET("warehouse/part-masters", {page_size: 10000,  page: 0}),
          GET("warehouse/purchase-requisitions", {page_size: 10000,  page: 0}),
        ]);
      if (result_suppliers?.status) {
        data_suppliers = result_suppliers?.data.map(e=>({value: e.uid, label: e.name})) || [];
      
      }
      if (result_parts?.status) {
        data_parts = result_parts?.data.map(e=>({...e, value: e.uid, label: e.part_number + " : " + e.name})) || [];
      }
      let summary_pr = this.state.summary_pr;
      if (result_pr?.status) {
        const all_pr = result_pr?.data || [];
        // อ้างอิงเป็น PO ได้เฉพาะ PR ที่อนุมัติแล้วและยังไม่มี PO (backend บังคับเหมือนกัน)
        data_all_pr = all_pr
          .filter((e) => e.status === "approved" && !e?.purchase_orders?.po_number)
          .map((e) => ({ ...e, value: e.uid, label: e.pr_number }));
        summary_pr = all_pr.reduce((acc, e) => {
          acc.total += 1;
          if (e.status === "pending") acc.pending += 1;
          if (e?.purchase_orders?.po_number) acc.converted_to_po += 1;
          else if (e.status === "approved") acc.approved += 1;
          return acc;
        }, { total: 0, pending: 0, approved: 0, converted_to_po: 0 });
      }

      this.setState({
        data_suppliers: data_suppliers,
        data_parts: data_parts,
        data_all_pr: data_all_pr,
        summary_pr
      });
      loading(false);
    };
  // -----------------------------------
  // API: Purchase Requisitions (PR)
  // -----------------------------------
  GetPR = async (page) => {
    const { filter_pr_search, filter_pr_status, filter_pr_priority } = this.state;
    loading(true);
    let result = await GET("warehouse/purchase-requisitions", { 
        page_size: 10, 
        page: page, 
        data_search: filter_pr_search || "",
        status: filter_pr_status || "",
        priority: filter_pr_priority || "",
    });
    if (result?.status) {
      this.setState({ 
        data_pr: result.data || [], 
        count_pr: result.pagination?.count || 0,
        page_pr: page,
      });
    }
    loading(false);
  };

  CreatePR = async () => {
    const { form_pr_priority, form_pr_required_date, form_pr_reason, form_pr_note, form_pr_supplier_id, form_pr_items, form_pr_notes_update } = this.state;

    if (!form_pr_supplier_id) {
      alert("", "warning", t("warning"), t("pr_supplier_required"));
      return;
    }
    if (form_pr_items.length === 0) {
      alert("", "warning", t("warning"), t("add_at_least_one_item"));
      return;
    }
    if (!this.validateItems(form_pr_items)) return;

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      
      let total_amount = 0;
      let items = form_pr_items.map(item => {
        let estimated_total = (Number(item.quantity) * Number(item.estimated_unit_cost));
        total_amount += estimated_total;
        return {
          part_id: item.part_id,
          uom_id: item.uom_id,
          quantity: Number(item.quantity) || 0,
          estimated_unit_cost: Number(item.estimated_unit_cost) || 0,
          estimated_total: estimated_total,
          discount: 0,
          notes: item.notes || "",
          notes_update: item.notes_update || ""
        };
      });

      let body = {
        company_id: company?.id || "446a2297-d012-43a1-af6c-eda4055099cf",
        priority: form_pr_priority,
        required_date: form_pr_required_date ? form_pr_required_date.replace("T", " ") : "", // แปลง datetime-local เป็น format API
        required_reason: form_pr_reason,
        discount: 0,
        total_items: items.length,
        total_amount: total_amount,
        status: "pending",
        notes: form_pr_note,
        notes_update: form_pr_notes_update,
        supplier_id: form_pr_supplier_id,
        items: items
      };

      let result = await POST("warehouse/purchase-requisitions", body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create_pr: false });
        this.resetFormPR();
        this.Get();
        this.GetPR(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error"));
      }
      loading(false);
    }
  };

  // -----------------------------------
  // API: Purchase Orders (PO)
  // -----------------------------------
  GetPO = async (page) => {
    const { filter_po_search, filter_po_status } = this.state;
    loading(true);
    let [result, summaryResult] = await Promise.all([
      GET("warehouse/purchase-orders", {
        page_size: 10,
        page: page,
        data_search: filter_po_search || "",
        status: filter_po_status || "",
      }),
      GET("warehouse/purchase-orders", {
        page_size: 10000,
        page: 0,
      })
    ]);

    if (result?.status) {
      const summaryData = summaryResult?.status ? (summaryResult.data || []) : [];
      const summary_po = summaryData.reduce((acc, item) => {
        const statusKey = (item.status || "").toLowerCase();
        acc.total += 1;

        if (statusKey === "pending") {
          acc.pending += 1;
        }
        if (statusKey === "sent_to_supplier") {
          acc.sent_to_supplier += 1;
        }
        if (statusKey === "awaiting_receipt" || statusKey === "partial") {
          acc.awaiting_receipt += 1;
        }
        if (statusKey === "received") {
          acc.received += 1;
        }

        return acc;
      }, { total: 0, pending: 0, sent_to_supplier: 0, awaiting_receipt: 0, received: 0 });

      this.setState({ 
        data_po: result.data || [], 
        count_po: result.pagination?.count || 0,
        page_po: page,
        summary_po
      });
    }
    loading(false);
  };

  CreatePO = async () => {
    const { form_po_date, form_po_due_date, form_po_pr_id, form_po_supplier_id, form_po_note, form_po_items } = this.state;
    
    // PO ต้องมีผู้จำหน่ายเสมอ (purchase_orders.supplier_id NOT NULL) แม้ PR ต้นทางจะไม่ได้ระบุไว้
    if (!form_po_supplier_id) {
      alert("", "warning", t("warning"), t("po_supplier_required"));
      return;
    }
    if (form_po_items.length === 0) {
      alert("", "warning", t("warning"), t("add_at_least_one_item"));
      return;
    }
    if (!this.validateItems(form_po_items)) return;

    if (await alert("", "info", t("confirm"), t("confirm_submission"), t("confirm"), t("cancel"))) {
      loading(true);
      
      let total_amount = 0;
      let items = form_po_items.map(item => {
        let line_total = (Number(item.quantity) * Number(item.unit_cost));
        total_amount += line_total;
        return {
          part_id: item.part_id,
          uom_id: item.uom_id,
          quantity: Number(item.quantity) || 0,
          unit_cost: Number(item.unit_cost) || 0,
          discount: 0,
          total: line_total,
          notes: item.notes || ""
        };
      });

      let body = {
          company_id: company?.id || "446a2297-d012-43a1-af6c-eda4055099cf",
          po_date: form_po_date ? form_po_date.replace("T", " ") : "",
          due_date: form_po_due_date ? form_po_due_date.replace("T", " ") : "",
          pr_id: form_po_pr_id,
          discount: 0,
          total_items: items.length,
          total_amount: total_amount,
          status: "pending",
          notes: form_po_note,
          supplier_id: form_po_supplier_id,
          items: items,
      };

      let result = await POST("warehouse/purchase-orders", body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create_po: false });
        this.resetFormPO();
        this.setActiveTab("PO");
        this.Get();
        this.GetPR(this.state.page_pr);
        this.GetPO(1);
      } else {
        alert("", "warning", t("warning"), result?.message || t("error"));
      }
      loading(false);
    }
  };

  // ดึง PR มาเติมฟอร์ม PO (ผู้จำหน่าย วันที่ต้องการ หมายเหตุ รายการ) ให้ผู้ใช้ตรวจ/เลือกผู้จำหน่ายก่อนกดสร้าง
  // ใช้ทั้งปุ่ม "สร้าง PO" ในแถว PR และตอนเลือก PR อ้างอิงใน modal สร้าง PO
  fillPOFromPR = async (prUid) => {
    if (!prUid) {
      this.setState({ form_po_pr_id: "" });
      return false;
    }

    loading(true);
    const detailResult = await GET("warehouse/purchase-requisitions", { uid: prUid });
    loading(false);
    const prData = detailResult?.data;

    if (!detailResult?.status || !prData) {
      alert("", "error", t("error"), detailResult?.message || t("cannot_fetch_pr_data"));
      return false;
    }

    const items = (prData.items || []).map((item) => ({
      part_id: item?.part?.uid || "",
      uom_id: item?.part?.uom?.uid || "",
      quantity: Number(item.quantity) || 0,
      unit_cost: Number(item.estimated_unit_cost) || 0,
      discount: Number(item.discount) || 0,
      notes: item.notes || "",
    }));

    if (items.length === 0) {
      alert("", "warning", t("warning"), t("pr_no_items_error"));
      return false;
    }

    const now = new Date();
    const pad = (value) => String(value).padStart(2, "0");
    // input datetime-local ต้องการรูปแบบ YYYY-MM-DDTHH:mm
    const toInputDate = (value) => (value ? String(value).replace(" ", "T").slice(0, 16) : "");

    this.setState({
      form_po_pr_id: prData.uid,
      form_po_date: `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}T${pad(now.getHours())}:${pad(now.getMinutes())}`,
      form_po_due_date: toInputDate(prData?.requester?.required_date),
      form_po_supplier_id: prData?.supplier?.uid || "",
      form_po_note: prData?.notes || "",
      form_po_items: items,
    });
    return true;
  };

  handleCreatePOFromPR = async (prItem) => {
    if (!prItem?.uid) {
      alert("", "warning", t("warning"), t("pr_data_not_found"));
      return;
    }

    this.resetFormPO();
    if (await this.fillPOFromPR(prItem.uid)) {
      this.setState({ modal_create_po: true });
    }
  };


  handleView = async (item, type) => {
    loading(true);
    const endpoint = type === "PR" ? "warehouse/purchase-requisitions" : "warehouse/purchase-orders";
    const result = await GET(endpoint, { uid: item.uid });
    loading(false);
    if (!result?.status || !result?.data) {
      alert("", "error", t("error"), result?.message || t("error"));
      return;
    }
    this.setState({ view_data: result.data, view_type: type, modal_view: true });
  };

  handleUpdateStatus = async (item, type, newStatus) => {
    if (!item?.uid) {
      alert("", "warning", t("warning"), t("record_not_found_for_update"));
      return;
    }

    const isApprove = newStatus === "approved" || newStatus === "sent_to_supplier";
    const actionText = isApprove ? t("approve") : t("reject");
    const { note, note_update } = this.state;

    if (await alert("", isApprove ? "success" : "warning", t("confirm_transaction_title"), `${t("confirm_action_prefix")}${actionText}${t("confirm_action_suffix")}`, t("confirm_yes"), t("cancel"))) {
      loading(true);
      
      const endpoint = type === "PR" 
        ? `warehouse/purchase-requisitions/${item.uid}` 
        : `warehouse/purchase-orders/${item.uid}`;

      let payload = { status: newStatus };
      if (note?.trim()) {
        payload.notes = note.trim();
      }

      if (note_update?.trim()) {
          payload.notes_update = note_update.trim();
      }

      let result = await PUT(endpoint, payload);
      
      if (result?.status === true || result?.status === 200 || result?.status === 201) {
        alert("#", "success", t("success"), `${t("update_status_to_prefix")} ${actionText} ${t("success_suffix")}`);
        this.setState({
          modal_update_pr: false,
          modal_update_po: false,
          uid: "",
          status: "pending",
          selected_item: null,
          note: "",
          note_update: ""
        }, () => this.setActiveTab(type));
        if (type === "PR") {
          // PR ที่เพิ่งอนุมัติต้องขึ้นใน dropdown อ้างอิงของ PO และ KPI ด้วย
          this.Get();
          this.GetPR(this.state.page_pr);
        } else this.GetPO(this.state.page_po);
      } else {
        alert("", "error", t("error"), result?.message || t("cannot_update_status"));
      }
      loading(false);
    }
  };

  // ยืนยันว่าได้ส่งข้อมูล PO ให้ผู้จำหน่ายแล้ว -> เปลี่ยนสถานะเป็น awaiting_receipt (รอรับสินค้า)
  handleConfirmSentToSupplier = async (item) => {
    if (!item?.uid) {
      alert("", "warning", t("warning"), t("record_not_found_for_update"));
      return;
    }

    if (await alert("", "info", t("confirm_transaction_title"), t("confirm_sent_to_supplier_message"), t("confirm_yes"), t("cancel"))) {
      loading(true);
      const result = await PUT(`warehouse/purchase-orders/${item.uid}`, { status: "awaiting_receipt" });
      if (result?.status === true || result?.status === 200 || result?.status === 201) {
        alert("#", "success", t("success"), `${t("update_status_to_prefix")} ${t("awaiting_receipt_status")} ${t("success_suffix")}`);
        this.GetPO(this.state.page_po);
      } else {
        alert("", "error", t("error"), result?.message || t("cannot_update_status"));
      }
      loading(false);
    }
  };

  // -----------------------------------
  // Helpers
  // -----------------------------------
  formatNumber = (num) => {
    return Number(num || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  resetFormPR = () => {
    this.setState({
      form_pr_priority: "normal", form_pr_required_date: "", form_pr_reason: "",
      form_pr_supplier_id: "", form_pr_note: "", form_pr_items: [],
      form_pr_notes_update: ""
    });
  };

  getPriorityBadgeClass = (priority) => {
    const priorityKey = (priority || "").toLowerCase();

    if (priorityKey === "low") {
      return "bg-secondary-light text-secondary border border-secondary";
    }
    if (priorityKey === "normal") {
      return "bg-primary-light text-primary border border-primary";
    }
    if (priorityKey === "high") {
      return "bg-warning-light text-warning border border-warning";
    }
    if (priorityKey === "urgent") {
      return "bg-danger-light text-danger border border-danger";
    }

    return "bg-light text-dark border";
  };

  getStatusBadgeClass = (status) => {
    const statusKey = (status || "").toLowerCase();

    if (statusKey === "pending") {
      return "bg-warning-light text-warning border border-warning";
    }
    if (statusKey === "approved" || statusKey === "received") {
      return "bg-success-light text-success border border-success";
    }
    if (statusKey === "partial") {
      return "bg-info-light text-info border border-info";
    }
    if (statusKey === "cancel" || statusKey === "cancelled" || statusKey === "rejected") {
      return "bg-danger-light text-danger border border-danger";
    }
    if (statusKey === "sent_to_supplier") {
        return "bg-info-light text-info border border-info";
    }
    if (statusKey === "awaiting_receipt") {
      return "bg-purple-light text-purple border border-purple";
    }

    return "bg-light text-dark border";
  };

  resetFormPO = () => {
    this.setState({
      form_po_date: "", form_po_due_date: "", form_po_pr_id: "",
      form_po_supplier_id: "", form_po_note: "", form_po_items: []
    });
  };

  // ตรวจรายการก่อนส่ง — แถวที่ยังไม่เลือกอะไหล่/ไม่มีหน่วย จะโดน backend ตีกลับเป็น Validation failed
  validateItems = (items) => {
    if (items.some((item) => !item.part_id || !item.uom_id)) {
      alert("", "warning", t("warning"), t("item_part_required"));
      return false;
    }
    if (items.some((item) => !(Number(item.quantity) > 0))) {
      alert("", "warning", t("warning"), t("item_quantity_required"));
      return false;
    }
    return true;
  };

  // ราคาตั้งต้นใช้ต้นทุนต่อหน่วยของอะไหล่ (uom_cost) และตั้งใหม่เฉพาะตอนเปลี่ยนอะไหล่
  // ไม่ทับราคาที่ผู้ใช้แก้เองหรือราคาที่ดึงมาจาก PR เวลาแก้จำนวน
  applyPartDefaults = (item, priceField) => {
    const part = this.state.data_parts.find((p) => p.value === item.part_id);
    item.uom_id = part?.uom?.uid || "";
    item[priceField] = Number(part?.uom_cost) || 0;
  };

  // จัดการ Items ในตาราง PR
  addPrItem = () => {
    this.setState(prevState => ({
      form_pr_items: [...prevState.form_pr_items, { part_id: "", uom_id: "", quantity: 1, estimated_unit_cost: 0, discount: 0, notes: "", notes_update: "" }]
    }));
  };
  updatePrItem = (index, field, value) => {
    let items = [...this.state.form_pr_items];
    items[index] = { ...items[index], [field]: value };
    if (field === "part_id") this.applyPartDefaults(items[index], "estimated_unit_cost");
    this.setState({ form_pr_items: items });
  };
  removePrItem = (index) => {
    let items = [...this.state.form_pr_items];
    items.splice(index, 1);
    this.setState({ form_pr_items: items });
  };

  // จัดการ Items ในตาราง PO
  addPoItem = () => {
    this.setState(prevState => ({
      form_po_items: [...prevState.form_po_items, { part_id: "", uom_id: "", quantity: 1, unit_cost: 0, discount: 0, notes: "" }]
    }));
  };
  updatePoItem = (index, field, value) => {
    let items = [...this.state.form_po_items];
    items[index] = { ...items[index], [field]: value };
    if (field === "part_id") this.applyPartDefaults(items[index], "unit_cost");
    this.setState({ form_po_items: items });
  };
  removePoItem = (index) => {
    let items = [...this.state.form_po_items];
    items.splice(index, 1);
    this.setState({ form_po_items: items });
  };

  // -----------------------------------
  // Render: PR Tab
  // -----------------------------------
  renderPRTab() {
    const { data_pr, summary_pr, filter_pr_search, filter_pr_status, filter_pr_priority, count_pr, modal_update_pr, uid, status, selected_item, note, note_update } = this.state;

    return (
        <>
            {/* KPI Cards PR */}
            <div className="row g-3 mb-4">
                <div className="col-lg-3 col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf15b"}</div>
                            <div>
                                <h3 className="fw-bold text-dark mb-0">{fmtInt(summary_pr.total)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("total_pr")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf017"}</div>
                            <div>
                                <h3 className="fw-bold text-dark mb-0">{fmtInt(summary_pr.pending)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("pending")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf058"}</div>
                            <div>
                                <h3 className="fw-bold text-dark mb-0">{fmtInt(summary_pr.approved)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("approved")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf0ec"}</div>
                            <div>
                                <h3 className="fw-bold text-dark mb-0">{fmtInt(summary_pr.converted_to_po)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("converted_to_po")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                <div className="border-bottom border-light d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex gap-3 flex-wrap flex-grow-1">
                        <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                            <input
                                type="text"
                                className="form-control ps-5 wpx-300"
                                style={{ height: "38px" }}
                                placeholder={t("search_placeholder")}
                                value={filter_pr_search}
                                onChange={(e) => this.setState({ filter_pr_search: e.target.value })}
                            />
                        </div>
                        <Select
                            className="form-control wpx-150"
                            options={[
                                { value: "pending", label: t("pending") },
                                { value: "rejected", label: t("reject") },
                                { value: "approved", label: t("approved") },
                            ]}
                            value={filter_pr_status}
                            onChange={(e) => this.setState({ filter_pr_status: e })}
                            placeholder={t("all_statuses")}
                            defaultLabel={t("all_statuses")}
                        />
                        <Select
                            className="form-control wpx-150"
                            options={[
                                { value: "low", label: t("low") },
                                { value: "normal", label: t("normal") },
                                { value: "high", label: t("high") },
                                { value: "urgent", label: t("urgent") },
                            ]}
                            value={filter_pr_priority}
                            onChange={(e) => this.setState({ filter_pr_priority: e })}
                            placeholder={t("all_priorities")}
                            defaultLabel={t("all_priorities")}
                        />
                        <div className="d-flex gap-2">
                            <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.GetPR(1)}>
                                {t("filter")}
                            </button>
                            <button
                                className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                onClick={() =>
                                    this.setState(
                                        {
                                            filter_pr_search: "",
                                            filter_pr_status: "",
                                            filter_pr_priority: "",
                                        },
                                        () => this.GetPR(1)
                                    )
                                }
                            >
                                {t("clear_all")}
                            </button>
                        </div>
                    </div>
                    <div>
                        {can("pr.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                            onClick={() => { this.resetFormPR(); this.setState({ modal_create_pr: true }); }}
                        >
                            <span className="me-2 text-16">+</span> {t("create_pr")}
                        </button>)}
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-4 shadow-sm pb-2">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0" style={{ minWidth: "1100px" }}>
                        <thead>
                            <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                <th className="py-3 border-0 wpx-150">{t("pr_number")}</th>
                                <th className="py-3 border-0 wpx-150">{t("po_number")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("created_date")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("required_date")}</th>
                                <th className="py-3 border-0 text-center wpx-100">{t("items")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("estimated_amount")}</th>
                                <th className="py-3 border-0 text-center wpx-120">{t("priority")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("status")}</th>
                                {/* ปุ่ม action ปักไว้ขวาสุด (sticky) ตารางกว้างกว่าจอ เลื่อนแล้วยังกดได้ทันที */}
                                <th className="py-3 border-0 text-center wpx-150 bg-white" style={STICKY_ACTION_STYLE}>{t("manage")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data_pr.length > 0 ? (
                                data_pr.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        <td className="text-nowrap">
                                            <span className="fw-bold text-primary text-14 pointer hover-underline">{item.pr_number || ""}</span>
                                        </td>
                                        <td className="text-nowrap">
                                            <span className="text-14 pointer hover-underline">{item?.purchase_orders?.po_number || ""}</span>
                                        </td>
                                        <td className="text-nowrap text-center text-secondary text-14">{item.created_at ? format_date(item.created_at, "dd-mm-yyyy", "th") : "-"}</td>
                                        <td className="text-nowrap text-center text-dark text-14">{item.pr_date ? format_date(item.pr_date, "dd-mm-yyyy", "th") : "-"}</td>
                                        <td className="text-nowrap text-center text-dark text-14">{fmtInt(item.total_items)}</td>
                                        <td className="text-nowrap text-center text-dark text-14">{this.formatNumber(item.total_amount)}</td>
                                        <td className="text-nowrap text-center">
                                            <span
                                                className={`badge px-2 py-1 rounded-pill d-inline-flex align-items-center justify-content-center ${this.getPriorityBadgeClass(item.priority)}`}
                                                style={{ minWidth: "78px" }}
                                            >
                                                {item.priority ? t(item.priority.toLowerCase()) : "-"}
                                            </span>
                                        </td>
                                        <td className="text-nowrap text-center">
                                            <span
                                                className={`badge rounded-pill px-3 py-1 text-10 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(item.status)}`}
                                                style={{ minWidth: "96px" }}
                                            >
                                                {item.status.replaceAll("_", " ").toUpperCase() || "PENDING"}
                                            </span>
                                        </td>
                                        <td className="text-nowrap text-center bg-white" style={STICKY_ACTION_STYLE}>
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.handleView(item, "PR")} />
                                                {(item.status === "pending") && can("pr.update") && (
                                                    <ActionIconButton
                                                        label={t("edit_status_tooltip")}
                                                        icon={ACTION_ICONS.edit}
                                                        variant="warning"
                                                        onClick={() =>
                                                            this.setState({
                                                                modal_update_pr: true,
                                                                uid: item.uid,
                                                                status: item.status || "pending",
                                                                selected_item: item,
                                                                note: item.notes || "",
                                                                note_update: item.notes_update || ""
                                                            })
                                                        }
                                                    />
                                                )}
                                                {item.status === "approved" && !item?.purchase_orders?.po_number && can("po.create") && (
                                                    <ActionIconButton label={t("create_po")} icon={"\uf0ec"} variant="secondary" onClick={() => this.handleCreatePOFromPR(item)} />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4 text-secondary">
                                        {t("no_data_found")} PR
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data_pr.length} {t("of")} {fmtInt(count_pr)} {t("records")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count_pr / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.GetPR(page)} />
                </div>
            </div>
        </>
    );
  }

  // -----------------------------------
  // Render: PO Tab
  // -----------------------------------
  renderPOTab() {
    const { data_po, summary_po, filter_po_search, filter_po_status, filter_po_supplier, count_po } = this.state;
    
    return (
        <>
            {/* KPI Cards PO */}
            <div className="row g-3 mb-4">
                <div className="col-lg col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-primary-light text-primary d-flex align-items-center justify-content-center text-20 icon">{"\uf571"}</div>
                            <div>
                                <h3 className="fw-bold text-dark mb-0">{fmtInt(summary_po.total)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("total_po")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-warning-light text-warning d-flex align-items-center justify-content-center text-20 icon">{"\uf017"}</div>
                            <div>
                                <h3 className="fw-bold text-warning mb-0">{fmtInt(summary_po.pending)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("pending")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-info-light text-info d-flex align-items-center justify-content-center text-20 icon">{"\uf1d8"}</div>
                            <div>
                                <h3 className="fw-bold text-info mb-0">{fmtInt(summary_po.sent_to_supplier)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("sent_to_supplier")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-purple-light text-purple d-flex align-items-center justify-content-center text-20 icon">{"\uf07a"}</div>
                            <div>
                                <h3 className="fw-bold text-purple mb-0">{fmtInt(summary_po.awaiting_receipt)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("awaiting_receipt_status")}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg col-md-6">
                    <div className="card border-0 rounded-4 shadow-sm p-3 h-100 bg-white">
                        <div className="d-flex align-items-center">
                            <div className="wpx-40 hpx-40 me-3 rounded-3 bg-success-light text-success d-flex align-items-center justify-content-center text-20 icon">{"\uf00c"}</div>
                            <div>
                                <h3 className="fw-bold text-success mb-0">{fmtInt(summary_po.received)}</h3>
                                <div className="text-secondary text-12 fw-bold">{t("received_status")}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                <div className="border-bottom border-light d-flex flex-wrap justify-content-between align-items-center gap-3">
                    <div className="d-flex gap-3 flex-wrap flex-grow-1">
                        <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                            <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                            <input
                                type="text"
                                className="form-control ps-5 wpx-300"
                                style={{ height: "38px" }}
                                placeholder={t("search_placeholder")}
                                value={filter_po_search}
                                onChange={(e) => this.setState({ filter_po_search: e.target.value })}
                            />
                        </div>
                        <Select
                            className="form-control wpx-150"
                            options={[
                                { value: "pending", label: t("pending") },
                                { value: "sent_to_supplier", label: t("sent_to_supplier") },
                                { value: "awaiting_receipt", label: t("awaiting_receipt_status") },
                                { value: "partial", label: t("po_status_partial") },
                                { value: "received", label: t("received_status") },
                                { value: "rejected", label: t("reject") },
                            ]}
                            value={filter_po_status}
                            onChange={(e) => this.setState({ filter_po_status: e })}
                            placeholder={t("all_statuses")}
                            defaultLabel={t("all_statuses")}
                        />
                        <div className="d-flex gap-2">
                            <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.GetPO(1)}>
                                {t("filter")}
                            </button>
                            <button
                                className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                onClick={() =>
                                    this.setState(
                                        {
                                            filter_po_search: "",
                                            filter_po_status: "",
                                        },
                                        () => this.GetPO(1)
                                    )
                                }
                            >
                                {t("clear_all")}
                            </button>
                        </div>
                    </div>
                    <div>
                        {can("po.create") && (
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                            onClick={() => { this.resetFormPO(); this.setState({ modal_create_po: true }); }}
                        >
                            <span className="me-2 text-16">+</span> {t("create_po")}
                        </button>)}
                    </div>
                </div>
            </div>

            <div className="bg-white rounded-4 shadow-sm pb-2">
                <div className="table-responsive">
                    <table className="table table-hover align-middle mb-0" style={{ minWidth: "1100px" }}>
                        <thead>
                            <tr className="text-secondary fw-bold text-12 border-bottom border-light">
                                <th className="py-3 border-0 text-left wpx-150">{t("po_number")}</th>
                                <th className="py-3 border-0 text-left wpx-150">{t("pr_number")}</th>
                                <th className="py-3 border-0 text-left wpx-150">{t("supplier")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("order_date")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("expected_date")}</th>
                                <th className="py-3 border-0 text-center wpx-50">{t("items")}</th>
                                <th className="py-3 border-0 text-center wpx-150">{t("total_amount")}</th>
                                <th className="py-3 border-0 text-center wpx-120">{t("status")}</th>
                                <th className="py-3 border-0 text-center wpx-120 bg-white" style={STICKY_ACTION_STYLE}>{t("manage")}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data_po.length > 0 ? (
                                data_po.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        <td className="text-nowrap">
                                            <div className="fw-bold text-primary text-14 pointer hover-underline">{item.po_number || "-"}</div>
                                        </td>
                                        <td className="text-nowrap text-dark text-14">{item.pr_number || "-"}</td>
                                        <td className="text-nowrap text-dark text-14">{item.supplier?.name || "-"}</td>
                                        <td className="text-nowrap text-center text-secondary text-14">{item.po_date ? format_date(item.po_date, "dd-mm-yyyy", "th") : "-"}</td>
                                        <td className="text-nowrap text-center fw-bold text-dark text-14">{item.due_date ? format_date(item.due_date, "dd-mm-yyyy", "th") : "-"}</td>
                                        <td className="text-nowrap text-center fw-bold text-dark text-14">{item.items?.length}</td>
                                        <td className="text-nowrap text-center fw-bold text-dark text-14">{this.formatNumber(item.total_amount)}</td>
                                        <td className="text-nowrap text-center">
                                            <span
                                                className={`badge rounded-pill px-3 py-1 text-10 d-inline-flex align-items-center justify-content-center ${this.getStatusBadgeClass(item.status)}`}
                                                style={{ minWidth: "120px" }}
                                            >
                                                {item.status.replaceAll("_", " ").toUpperCase() || "PENDING"}
                                            </span>
                                        </td>
                                        <td className="text-nowrap text-center bg-white" style={STICKY_ACTION_STYLE}>
                                            <div className="d-flex align-items-center gap-2 justify-content-center">
                                                <ActionIconButton label={t("view")} icon={ACTION_ICONS.view} variant="primary" onClick={() => this.handleView(item, "PO")} />
                                                {item.status === "pending" && can("po.update") && (
                                                    <ActionIconButton
                                                        label={t("edit_status_tooltip")}
                                                        icon={ACTION_ICONS.edit}
                                                        variant="warning"
                                                        onClick={() =>
                                                            this.setState({
                                                                modal_update_po: true,
                                                                uid: item.uid,
                                                                status: item.status || "pending",
                                                                selected_item: item,
                                                                note: item.notes || "",
                                                                note_update: item.notes_update || "",
                                                            })
                                                        }
                                                    />
                                                )}
                                                {item.status === "sent_to_supplier" && can("po.update") && (
                                                    <ActionIconButton
                                                        label={t("confirm_send_to_supplier_tooltip")}
                                                        icon={"\uf1d8"}
                                                        variant="success"
                                                        onClick={() => this.handleConfirmSentToSupplier(item)}
                                                    />
                                                )}
                                                {item.status === "awaiting_receipt" && (
                                                    <ActionIconButton
                                                        label={t("view_invoice_tooltip")}
                                                        icon={"\uf07a"}
                                                        variant="primary"
                                                        // onClick={() => this.handleView(item, "Invoice")}
                                                    />
                                                )}
                                                {item.status === "received" && (
                                                    <ActionIconButton
                                                        label={t("view_invoice_tooltip")}
                                                        icon={"\uf02f"}
                                                        variant="primary"
                                                        // onClick={() => this.handleView(item, "Invoice")}
                                                    />
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4 text-secondary">
                                        {t("no_data_found")} PO
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} 1-{data_po.length} {t("of")} {fmtInt(count_po)} {t("records")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count_po / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.GetPO(page)} />
                </div>
            </div>
        </>
    );
  }

  render() {
    const { 
      data_suppliers,
      data_parts,
      data_all_pr,
      active_tab, 
      modal_create_pr, form_pr_priority, form_pr_required_date, form_pr_reason, form_pr_supplier_id, form_pr_note, form_pr_items,
      modal_create_po, form_po_date, form_po_due_date, form_po_pr_id, form_po_supplier_id, form_po_note, form_po_items,
      modal_view, view_data, view_type,
      modal_update_pr, modal_update_po, selected_item, note, note_update
    } = this.state;
    
    const total_pr_amount = form_pr_items.reduce((sum, item) => sum + ((Number(item.quantity) * Number(item.estimated_unit_cost))), 0);
    const total_po_amount = form_po_items.reduce((sum, item) => sum + ((Number(item.quantity) * Number(item.unit_cost))), 0);

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                <div className="mb-4">
                    <h3 className="fw-bold mb-1 text-dark">{t("pr_po_title")}</h3>
                    <div className="text-secondary text-14">{t("pr_po_subtitle")}</div>
                </div>

                {/* Tabs Control */}
                <div className="d-flex border-bottom border-light mb-4 text-14">
                    <div
                        className={`py-2 px-4 pointer d-flex align-items-center fw-bold transition-hover ${active_tab === "PR" ? "text-primary" : "text-secondary"}`}
                        style={{ borderBottom: active_tab === "PR" ? "3px #1976D2 solid" : "" }}
                        onClick={() => this.setActiveTab("PR", () => this.GetPR(1))}
                    >
                        <span className="icon me-2">{"\uf15b"}</span> {t("pr_tab")}
                    </div>
                    <div
                        className={`py-2 px-4 pointer d-flex align-items-center fw-bold transition-hover ${active_tab === "PO" ? "text-primary" : "text-secondary"}`}
                        style={{ borderBottom: active_tab === "PO" ? "3px #1976D2 solid" : "" }}
                        onClick={() => this.setActiveTab("PO", () => this.GetPO(1))}
                    >
                        <span className="icon me-2">{"\uf571"}</span> {t("po_tab")}
                    </div>
                </div>

                {active_tab === "PR" ? this.renderPRTab() : this.renderPOTab()}
            </div>

            {/* ------------------------------------------- */}
            {/* MODAL: สร้างใบขอซื้อ (PR) */}
            {/* ------------------------------------------- */}
            <Modal size="lg" show={modal_create_pr} onHide={() => this.setState({ modal_create_pr: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom-0 pb-0 pt-4 px-4" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{t("create_pr_modal_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-3 mb-4">
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("priority")}</label>
                            <Select
                                className="form-control py-1"
                                options={[
                                    { value: "low", label: t("low") },
                                    { value: "normal", label: t("normal") },
                                    { value: "high", label: t("high") },
                                    { value: "urgent", label: t("urgent") },
                                ]}
                                value={form_pr_priority}
                                onChange={(e) => this.setState({ form_pr_priority: e })}
                                placeholder={t("normal")}
                                default={false}
                            />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("required_date")}</label>
                            <input type="datetime-local" className="form-control py-2" value={form_pr_required_date} onChange={(e) => this.setState({ form_pr_required_date: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("pr_reason_label")}</label>
                            <input type="text" className="form-control py-2" value={form_pr_reason} onChange={(e) => this.setState({ form_pr_reason: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("supplier")} <span className="text-danger">*</span></label>
                            <Select className="form-control py-1" options={data_suppliers} value={form_pr_supplier_id} placeholder={t("select_supplier")} onChange={(e) => this.setState({ form_pr_supplier_id: e })} />
                        </div>
                    </div>

                    {/* PR Items */}
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-dark mb-0">{t("items_list_title")}</h6>
                            <button className="btn btn-sm text-primary fw-bold" onClick={this.addPrItem}>
                                + {t("add_item")}
                            </button>
                        </div>
                        <div className="bg-light p-2 rounded-3 border border-light">
                            <table className="table align-middle mb-0">
                                <thead>
                                    <tr className="text-dark fw-bold text-12">
                                        <th>{t("part_code")}</th>
                                        <th className="text-center wpx-80">{t("quantity")}</th>
                                        <th className="text-start wpx-100">{t("unit")}</th>
                                        <th className="text-end wpx-100">{t("estimated_price")}</th>
                                        <th className="text-end wpx-100">{t("total")}</th>
                                        <th className="text-center wpx-40"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {form_pr_items.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <Select className="form-control" options={data_parts} value={item.part_id} nowrapOptions onChange={(e) => this.updatePrItem(idx, "part_id", e)} />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center"
                                                    value={item.quantity}
                                                    onChange={(e) => this.updatePrItem(idx, "quantity", e.target.value)}
                                                />
                                            </td>
                                            <td>{data_parts.find((part) => part.value === item.part_id)?.uom?.name || "-"}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm text-end"
                                                    value={item.estimated_unit_cost}
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) return;
                                                        this.updatePrItem(idx, "estimated_unit_cost", e.target.value);
                                                    }}
                                                />
                                            </td>
                                            <td className="text-end fw-bold">{this.formatNumber(Number(item.quantity) * Number(item.estimated_unit_cost))}</td>
                                            <td className="text-center">
                                                <span className="icon text-danger pointer" onClick={() => this.removePrItem(idx)}>
                                                    {"\uf2ed"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="4" className="text-end fw-bold pt-3">
                                            {t("net_total")}
                                        </td>
                                        <td className="text-end fw-bold pt-3 text-primary text-16">{this.formatNumber(total_pr_amount)}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div>
                        <label className="form-label text-14 fw-bold">{t("note")}</label>
                        <textarea className="form-control py-2" rows="2" value={form_pr_note} onChange={(e) => this.setState({ form_pr_note: e.target.value })}></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end">
                    <button className="btn btn-white border px-4 py-2 me-2" onClick={() => this.setState({ modal_create_pr: false })}>
                        {t("cancel")}
                    </button>
                    <button className="btn btn-primary px-4 py-2" onClick={this.CreatePR}>
                        {t("create_pr")}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* ------------------------------------------- */}
            {/* MODAL: สร้างใบสั่งซื้อ (PO) */}
            {/* ------------------------------------------- */}
            <Modal size="lg" show={modal_create_po} onHide={() => this.setState({ modal_create_po: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom-0 pb-0 pt-4 px-4" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">{t("create_po_modal_title")}</h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-3 mb-4">
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("order_date")}</label>
                            <input type="datetime-local" className="form-control py-2" value={form_po_date} onChange={(e) => this.setState({ form_po_date: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("due_date")}</label>
                            <input type="datetime-local" className="form-control py-2" value={form_po_due_date} onChange={(e) => this.setState({ form_po_due_date: e.target.value })} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("pr_reference_label")}</label>
                            <Select className="form-control" options={data_all_pr} value={form_po_pr_id} placeholder={t("select_pr_placeholder")} onChange={(e) => this.fillPOFromPR(e)} />
                        </div>
                        <div className="col-md-6">
                            <label className="form-label text-14 fw-bold">{t("supplier")} <span className="text-danger">*</span></label>
                            <Select className="form-control" options={data_suppliers} value={form_po_supplier_id} placeholder={t("select_supplier")} onChange={(e) => this.setState({ form_po_supplier_id: e })} />
                        </div>
                    </div>

                    {/* PO Items */}
                    <div className="mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-dark mb-0">{t("items_list_title")}</h6>
                            <button className="btn btn-sm text-primary fw-bold" onClick={this.addPoItem}>
                                + {t("add_item")}
                            </button>
                        </div>
                        <div className="bg-light p-2 rounded-3 border border-light">
                            <table className="table align-middle mb-0">
                                <thead>
                                    <tr className="text-dark fw-bold text-12">
                                        <th>{t("part_code")}</th>
                                        <th className="text-center wpx-80">{t("quantity")}</th>
                                        <th className="text-start wpx-100">{t("unit")}</th>
                                        <th className="text-end wpx-100">{t("estimated_price")}</th>
                                        <th className="text-end wpx-100">{t("total")}</th>
                                        <th className="text-center wpx-40"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {form_po_items.map((item, idx) => (
                                        <tr key={idx}>
                                            <td>
                                                <Select className="form-control" options={data_parts} value={item.part_id} nowrapOptions onChange={(e) => this.updatePoItem(idx, "part_id", e)} />
                                            </td>
                                            <td>
                                                <input
                                                    type="number"
                                                    className="form-control form-control-sm text-center"
                                                    value={item.quantity}
                                                    onChange={(e) => this.updatePoItem(idx, "quantity", e.target.value)}
                                                />
                                            </td>
                                            <td>{data_parts.find((part) => part.value === item.part_id)?.uom?.name || "-"}</td>
                                            <td>
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm text-end"
                                                    value={item.unit_cost}
                                                    onChange={(e) => {
                                                        if (!float(e.target.value)) return;
                                                        this.updatePoItem(idx, "unit_cost", e.target.value);
                                                    }}
                                                />
                                            </td>
                                            <td className="text-end fw-bold">{this.formatNumber(Number(item.quantity) * Number(item.unit_cost))}</td>
                                            <td className="text-center">
                                                <span className="icon text-danger pointer" onClick={() => this.removePoItem(idx)}>
                                                    {"\uf2ed"}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                    <tr>
                                        <td colSpan="4" className="text-end fw-bold pt-3">
                                            {t("net_total")}
                                        </td>
                                        <td className="text-end fw-bold pt-3 text-primary text-16">{this.formatNumber(total_po_amount)}</td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div>
                        <label className="form-label text-14 fw-bold">{t("note")}</label>
                        <textarea className="form-control py-2" rows="2" value={form_po_note} onChange={(e) => this.setState({ form_po_note: e.target.value })}></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end">
                    <button className="btn btn-white border px-4 py-2 me-2" onClick={() => this.setState({ modal_create_po: false })}>
                        {t("cancel")}
                    </button>
                    <button className="btn btn-primary px-4 py-2" onClick={this.CreatePO}>
                        {t("create_po")}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* ------------------------------------------- */}
            {/* MODAL: ดูรายละเอียด (View Detail) */}
            {/* ------------------------------------------- */}
            <Modal size="lg" show={modal_view} onHide={() => this.setState({ modal_view: false })} centered contentClassName="border-0 rounded-4 shadow-lg">
                <Modal.Header className="bg-white border-bottom-0 pb-0 pt-4 px-4" closeButton>
                    <h4 className="fw-bold mb-0 text-dark">
                        {t("details_title")} {view_type === "PR" ? t("pr_document_label") : t("po_document_label")}
                        <span className="ms-2 text-primary">#{view_data?.pr_number || view_data?.po_number || view_data?.id}</span>
                    </h4>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-3 mb-4">
                        <div className="col-md-3 col-6">
                            <label className="text-secondary text-12">{t("status")}</label>
                            <div className="fw-bold text-dark">{view_data?.status || "-"}</div>
                        </div>
                        <div className="col-md-3 col-6">
                            <label className="text-secondary text-12">{t("created_date")}</label>
                            <div className="fw-bold text-dark">{view_data?.created_at ? format_date(view_data?.created_at, "dd-mm-yyyy", "th") : "-"}</div>
                        </div>
                        <div className="col-md-3 col-6">
                            <label className="text-secondary text-12">{t("total_amount")}</label>
                            <div className="fw-bold text-primary">{this.formatNumber(view_data?.total_amount)}</div>
                        </div>
                        <div className="col-md-3 col-6">
                            <label className="text-secondary text-12">{t("note")}</label>
                            <div className="fw-bold text-dark">{view_data?.notes || "-"}</div>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <h6 className="fw-bold text-dark mb-0">{t("items_list_title")}</h6>
                    </div>
                    <div className="bg-light p-2 rounded-3 border border-light table-responsive">
                        <table className="table align-middle mb-0">
                            <thead>
                                <tr className="text-dark fw-bold text-12">
                                    <th>{t("part_code")}</th>
                                    <th className="text-center text-nowrap">{t("quantity")}</th>
                                    <th className="text-end text-nowrap">{t("unit_price")}</th>
                                    <th className="text-end text-nowrap">{t("total")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {view_data?.items && view_data.items.length > 0 ? (
                                    view_data.items.map((item, idx) => (
                                        <tr key={idx}>
                                            {/* รหัส : ชื่อ แบบเดียวกับตัวเลือกตอนสร้าง กินพื้นที่ที่เหลือทั้งหมดจนถึงคอลัมน์จำนวน
                                                ยาวเกินช่องตัดเป็น ... (ชี้ดูเต็มได้) - width 100% + maxWidth 0 ให้ช่องขยายเต็มแต่ไม่ดันตาราง */}
                                            <td style={{ width: "100%", maxWidth: 0 }}>
                                                <div
                                                    className="text-truncate"
                                                    title={[item.part?.part_number, item.part?.name].filter(Boolean).join(" : ")}
                                                >
                                                    {[item.part?.part_number, item.part?.name].filter(Boolean).join(" : ") || "-"}
                                                </div>
                                            </td>
                                            <td className="text-center text-nowrap">{fmtQty(item.quantity)}</td>
                                            <td className="text-end text-nowrap">{this.formatNumber(item.unit_cost || item.estimated_unit_cost)}</td>
                                            <td className="text-end fw-bold text-nowrap">{this.formatNumber(item.total || item.estimated_total)}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center text-secondary py-4">
                                            {t("no_item_detail_in_list")}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <label className="text-secondary text-12">{t("note")}</label>
                        <div className="fw-bold text-dark">{view_data?.notes_update || "-"}</div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 pt-0 px-4 pb-4 d-flex justify-content-end">
                    <button className="btn btn-secondary px-4 py-2" onClick={() => this.setState({ modal_view: false })}>
                        {t("close")}
                    </button>
                </Modal.Footer>
            </Modal>

            {/* ========================================================= */}
            {/* MODAL: อัปเดตสถานะ PR */}
            {/* ========================================================= */}
            <Modal
                show={modal_update_pr}
                onHide={() => this.setState({ modal_update_pr: false, uid: "", status: "pending", selected_item: null, note_update: "" })}
                centered
                contentClassName="border-0 rounded-4 shadow-lg"
            >
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{t("update_status_title")}</h5>
                </Modal.Header>
                <Modal.Body className="bg-white">
                    <div className="mb-3">
                        <label className="form-label text-14 text-secondary fw-bold mb-1">{t("reference")}</label>
                        <input type="text" className="form-control bg-light" value={selected_item?.pr_number || selected_item?.movement_code || "-"} disabled />
                    </div>
                    <div>
                        <label className="form-label text-14 text-secondary fw-bold mb-1">
                            {t("comment_label")} <span className="text-secondary">({t("optional")})</span>
                        </label>
                        <textarea
                            className="form-control shadow-none"
                            rows="3"
                            placeholder={t("comment_placeholder")}
                            value={note_update}
                            onChange={(e) => this.setState({ note_update: e.target.value })}
                        ></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-white border px-4 py-2 fw-bold"
                            onClick={() => this.setState({ modal_update_pr: false, uid: "", status: "pending", selected_item: null, note_update: "" })}
                        >
                            {t("cancel")}
                        </button>
                        <button className="btn btn-danger px-4 py-2 fw-bold" onClick={() => this.handleUpdateStatus(selected_item, "PR", "rejected")}>
                            <span className="icon me-2">{"\uf00d"}</span>
                            {t("reject")}
                        </button>
                        <button className="btn btn-success px-4 py-2 fw-bold" onClick={() => this.handleUpdateStatus(selected_item, "PR", "approved")}>
                            <span className="icon me-2">{"\uf00c"}</span>
                            {t("approve")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>

            {/* ========================================================= */}
            {/* MODAL: อัปเดตสถานะ PO */}
            {/* ========================================================= */}
            <Modal
                show={modal_update_po}
                onHide={() => this.setState({ modal_update_po: false, uid: "", status: "pending", selected_item: null, note_update: "" })}
                centered
                contentClassName="border-0 rounded-4 shadow-lg"
            >
                <Modal.Header className="bg-white border-bottom border-light px-4 py-3" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{t("update_status_title")}</h5>
                </Modal.Header>
                <Modal.Body className="bg-white">
                    <div className="mb-3">
                        <label className="form-label text-14 text-secondary fw-bold mb-1">{t("reference")}</label>
                        <input type="text" className="form-control bg-light" value={selected_item?.po_number || selected_item?.pr_number || selected_item?.movement_code || "-"} disabled />
                    </div>
                    <div>
                        <label className="form-label text-14 text-secondary fw-bold mb-1">
                            {t("comment_label")} <span className="text-secondary">({t("optional")})</span>
                        </label>
                        <textarea
                            className="form-control shadow-none"
                            rows="3"
                            placeholder={t("comment_placeholder")}
                            value={note_update}
                            onChange={(e) => this.setState({ note_update: e.target.value })}
                        ></textarea>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex gap-2">
                        <button
                            className="btn btn-white border px-4 py-2 fw-bold"
                            onClick={() => this.setState({ modal_update_po: false, uid: "", status: "pending", selected_item: null, note_update: "" })}
                        >
                            {t("cancel")}
                        </button>
                        <button className="btn btn-danger px-4 py-2 fw-bold" onClick={() => this.handleUpdateStatus(selected_item, "PO", "rejected")}>
                            <span className="icon me-2">{"\uf00d"}</span>
                            {t("reject")}
                        </button>
                        <button className="btn btn-success px-4 py-2 fw-bold" onClick={() => this.handleUpdateStatus(selected_item, "PO", "sent_to_supplier")}>
                            <span className="icon me-2">{"\uf00c"}</span>
                            {t("approve")}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}
